import React, { useState, useEffect } from "react";
import { IonSlides, IonSlide, IonLabel, IonCol, IonRow, IonText } from "@ionic/react";
import * as constants from "../../constants";

interface carBrandsProps {
  carBrands: Array<any>;
  saveBrandData: Function;
  selectedBrand: string;
  handleKeypressBrands: Function;
}

const SelectVehicleBrands: React.FC<carBrandsProps> = ({
  carBrands,
  saveBrandData,
  selectedBrand,
  handleKeypressBrands,
}: carBrandsProps) => {
  return (
    <>
      <IonRow
        className={
          carBrands.length
            ? "brands_div margin-left-right-0"
            : "no-variants-layout margin-left-right-0"
        }
      >
        {carBrands.length ? (
          carBrands.map((ele, index) => (
            <IonCol key={index} size-md="2" size="4">
              <div
                tabIndex={0}
                onKeyPress={(event) => handleKeypressBrands(event, ele.name, ele.makeId)}
                onClick={() => saveBrandData(ele.name, ele.makeId)}
                className={ele.name === selectedBrand ? "selected-brand" : "brands_data"}
              >
                <img src={ele.logoUrl} className="brand_img" alt="" />
                <IonText className="brand_name">{ele.name}</IonText>
              </div>
            </IonCol>
          ))
        ) : (
          <div>
            <h3 color="secondary">{constants.NO_BRANDS_FOUND}</h3>
          </div>
        )}
      </IonRow>
    </>
  );
};

export default SelectVehicleBrands;
